import React from 'react';
import moment from 'jalali-moment';

/*
    - ihoDesignSystem
*/
import { Box, Image, Typography } from '@iho-design-system/Loader';

/*
    - icons
*/
import InfoSVG from '../../../assets/images/help-desk/info.svg';
import UserSVG from '../../../assets/images/help-desk/user.svg';

const SelectReserve = ({ requestType, selectedReserve, selectedService }) => {

    return (

        <React.Fragment>

            {(requestType.split(',')[3] === 'selectReserve' || selectedService === 'awaiting' || selectedService === 'pending') &&
                <React.Fragment>
                    <Box
                        className={`w-100 my-sm`} />
                    <Box
                        className={`d-flex flex-wrap align-item-start justify-content-end position-relative`}
                        ms={{
                            opacity: '0',
                            bottom: '-16px',
                            animation: 'chatAnimation 0.25s linear',
                            animationFillMode: 'forwards'
                        }}>
                        <Box
                            className={`px-md py-xs rounded-sm rounded-bottom-left-0`}
                            ms={{
                                backgroundColor: 'var(--gray-dark)'
                            }}>
                            <Typography
                                className={`d-block`}
                                ms={{
                                    color: 'var(--white)'
                                }}>
                                {selectedReserve.hotelName}
                            </Typography>
                            <Typography
                                className={`d-block`}
                                ms={{
                                    color: 'var(--white)'
                                }}>
                                از {moment(selectedReserve.arrivalDate.split('T')[0], 'YYYY/MM/DD').locale('fa').format('YYYY/MM/DD').split('/')[2].replace('0', '')} تا {moment(selectedReserve.exitDate.split('T')[0], 'YYYY/MM/DD').locale('fa').format('YYYY/MM/DD').split('/')[2].replace('0', '')} {moment(selectedReserve.exitDate.split('T')[0], 'YYYY/MM/DD').locale('fa').format('YYYY/MMMM/DD').split('/')[1].replace('0', '')}
                            </Typography>
                            <Typography
                                className={`d-block`}
                                ms={{
                                    color: 'var(--white)'
                                }}>
                                کد پیگیری رزرو : {selectedReserve.nuRequest}{selectedReserve.reserveId}
                            </Typography>
                        </Box>
                        <Box
                            className={`mx-xs ml-0 my-sm mb-0 rounded-circle`}>
                            <Image
                                src={UserSVG}
                                alt='info'
                                ms={{
                                    width: '18px',
                                    height: '18px'
                                }} />
                        </Box>
                    </Box>
                    <Box
                        className={`w-100 my-sm`} />
                    <Box
                        className={`d-flex flex-wrap align-item-start position-relative`}
                        ms={{
                            opacity: '0',
                            bottom: '-16px',
                            animation: 'chatAnimation 0.25s linear',
                            animationFillMode: 'forwards',
                            animationDelay: '0.5s',
                        }}>
                        <Box
                            className={`p-xs mx-xs mr-0 my-sm mb-0 rounded-circle`}
                            ms={{
                                maxWidth: '60%',
                                backgroundColor: 'var(--gray-medium)'
                            }}>
                            <Image
                                src={InfoSVG}
                                alt='info'
                                ms={{
                                    width: '12px',
                                    height: '12px'
                                }} />
                        </Box>
                        <Box
                            className={`px-md py-xs rounded-sm rounded-bottom-right-0 toggle-opaccity`}
                            ms={{
                                maxWidth: '60%',
                                backgroundColor: 'var(--gray-medium)',
                            }}>
                            {(selectedService !== 'awaiting' && selectedService !== 'pending') &&
                                <Typography>
                                    {requestType.split(',')[1] === 'modifyRoom' &&
                                        <React.Fragment>
                                            لطفا تغییر یا حذف را، بر روی هر اتاق اعمال نمایید.
                                        </React.Fragment>
                                    }
                                    {requestType.split(',')[1] === 'cancel' &&
                                        <React.Fragment>
                                            آیا از درخواست کنسل کردن رزرو اطمینان دارید؟
                                        </React.Fragment>
                                    }
                                    {requestType.split(',')[1] === 'modifyDate' &&
                                        <React.Fragment>
                                            لطفا تاریخ جدید خود را، انتخاب نمایید.
                                        </React.Fragment>
                                    }
                                    {requestType.split(',')[1] === 'extraPassenger' &&
                                        <React.Fragment>
                                            لطفا تعداد نفر اضافه خود را، بر روی هر اتاق اعمال نمایید.
                                        </React.Fragment>
                                    }
                                    {requestType.split(',')[1] === 'halfCharge' &&
                                        <React.Fragment>
                                            لطفا نیم شارژ ورود یا خروج خود را، بر روی اتاق اعمال نمایید.
                                        </React.Fragment>
                                    }
                                    {requestType.split(',')[1] === 'hotelInfo' &&
                                        <React.Fragment>
                                            لطفا اطلاعاتی که نیاز دارید را، انتخاب نمایید.
                                        </React.Fragment>
                                    }
                                    {requestType.split(',')[1] === 'modifyPassenger' &&
                                        <React.Fragment>
                                            لطفا اطلاعات جدید مسافران را، بر روی هر اتاق اعمال نمایید.
                                        </React.Fragment>
                                    }
                                    {requestType.split(',')[1] === 'invoice' &&
                                        <React.Fragment>
                                            آیا از ارسال درخواست فاکتور رسمی اطمینان دارید؟
                                        </React.Fragment>
                                    }
                                    {requestType.split(',')[1] === 'transfer' &&
                                        <React.Fragment>
                                            لطفا اطلاعات ترنسفر خود را، اعمال نمایید.
                                        </React.Fragment>
                                    }
                                </Typography>
                            }
                            {(selectedService === 'awaiting' || selectedService === 'pending') &&
                                <Typography>
                                    {selectedService === 'awaiting' &&
                                        <React.Fragment>
                                            کاربر عزیز، شما یک درخواست مشابه در وضعیت "درانتظار بررسی" دارید.
                                        </React.Fragment>
                                    }
                                    {selectedService === 'pending' &&
                                        <React.Fragment>
                                            کاربر عزیز، شما یک درخواست مشابه در وضعیت "در حال بررسی" دارید.
                                        </React.Fragment>
                                    }
                                </Typography>
                            }
                        </Box>
                    </Box>
                    {(selectedService === 'awaiting' || selectedService === 'pending') &&
                        <React.Fragment>
                            <Box
                                className={`w-100 my-sm`} />
                            <Box
                                className={`d-flex flex-wrap align-item-start position-relative`}
                                ms={{
                                    opacity: '0',
                                    bottom: '-16px',
                                    animation: 'chatAnimation 0.25s linear',
                                    animationFillMode: 'forwards',
                                    animationDelay: '1s',
                                }}>
                                <Box
                                    className={`p-xs mx-xs mr-0 my-sm mb-0 rounded-circle`}
                                    ms={{
                                        maxWidth: '60%',
                                        backgroundColor: 'var(--gray-medium)'
                                    }}>
                                    <Image
                                        src={InfoSVG}
                                        alt='info'
                                        ms={{
                                            width: '12px',
                                            height: '12px'
                                        }} />
                                </Box>
                                <Box
                                    className={`px-md py-xs rounded-sm rounded-bottom-right-0 toggle-opaccity`}
                                    ms={{
                                        maxWidth: '60%',
                                        backgroundColor: 'var(--gray-medium)',
                                    }}>
                                    <Typography>
                                        کارشناسان ما به زودی پاسخ درخواستتان را خواهند داد.
                                    </Typography>
                                </Box>
                            </Box>
                        </React.Fragment>
                    }
                </React.Fragment>
            }

        </React.Fragment>

    );

}

export default SelectReserve;